import type { UseModelMutationOptions } from "@/hooks/queries/useModelMutation.type";
import type { ApiError } from "@/services/api";

import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useModelMutation = <Data = unknown, Variables = unknown>(
  model: string,
  id: number,
  options: UseModelMutationOptions<Data, Variables>
) => {
  const queryClient = useQueryClient();
  const { invalidateKeys, ...queryOptions } = options;

  const onSuccess = () => {
    invalidateKeys?.forEach((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    );

    // return model invalidation to make sure mutation state stays pending
    // until model query has finished to refetch
    return queryClient.invalidateQueries({ queryKey: [model, "get", id] });
  };

  return useMutation<Data, ApiError, Variables>({
    ...queryOptions,
    onSuccess,
  });
};
